<template>
    <main id="mainCtrl">
        <header>
            <button @click="createRole">
                <img src="data:image/png;base64,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" width="26">
                Создать новую роль
            </button>
        </header>
        <role-edit-dialog ref="roleEditDialog"
                          :permissions="permissions"
                          @closed="reload()"
        ></role-edit-dialog>
        <v-table id="table"
                 request-uri="roles/getList"
                 pagesize="50"
                 ref="table">
            <template v-slot:header>
                <v-tr>
                    <v-th minwidth="150" name="description" sort="description" v-slot="{filter}">
                        Название
                    </v-th>
                    <v-th width="40" name="users_count" sort="users_count" v-slot="{filter}">
                        <i class="fa fa-users"></i>
                    </v-th>
                </v-tr>
                <v-tr>
                    <v-th minwidth="150" name="description" v-slot="{filter}">
                        <v-input v-model="filter.value"/>
                    </v-th>
                    <v-th width="150" name="users_count" v-slot="{filter}">
                    </v-th>
                </v-tr>
            </template>
            <template v-slot:row="{ item, index }">
                <v-tr :class="{'hover': true, 'pointer': true, 'strong': item.self}"
                      @click="(row, event) => handleRowClick(event, item, row)">
                    <v-td>
                        {{item.description}}
                    </v-td>
                    <v-td>{{item.usersCount}}</v-td>
                </v-tr>
            </template>
        </v-table>
    </main>
</template>

<script>

import EditDialog from "@dialogs/admin/settings/roles/RoleEditDialog";

export default {
    name: "Page",

    props: {
        permissions: {
            type: Object,
            required: true,
        }
    },

    components: {
        'roleEditDialog': EditDialog,
    },

    methods: {
        handleRowClick: function (event, item, row) {
            row.startLoadingAnimation();
            let promise = this.editRole(item, row);
            promise.then(() => row.stopLoadingAnimation())
                .catch(() => row.stopLoadingAnimation());
            return promise;
        },

        reload () {
            this.$refs.table.update();
        },

        editRole: function (item) {
            return this.$refs.roleEditDialog.show(item);
        },
        createRole: function () {
            this.$refs.roleEditDialog.createRole();
        },
    }
}
</script>

<style scoped>

</style>
